"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCoffee = function IconCoffee(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M39 26V14H5v12a12 12 0 0 0 12 12h10a12 12 0 0 0 12-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeWidth: 2,
    d: "M41 19h1.25c2.071 0 3.75 1.79 3.75 4s-1.679 4-3.75 4H41M9 41.5h26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    d: "m18.194 3-.148.129a3.28 3.28 0 0 0-.56 4.117l.278.426.102.168a2.28 2.28 0 0 1-.336 2.7M22.389 3l-.147.129a3.28 3.28 0 0 0-.561 4.117l.278.426.102.168a2.28 2.28 0 0 1-.335 2.7M26.584 3l-.147.129a3.28 3.28 0 0 0-.561 4.117l.278.426.102.168a2.28 2.28 0 0 1-.335 2.7"
  })));
};

export { IconCoffee, IconCoffee as default };
